import { NAT_NUM_100_900 } from "../../../../SubjectData/BasicWords/Numbers/NatNums.js";
import "../../../Deck.css";
import FlashcardInterface from "../../../Flashcard_Interface.js";
import HeaderNav from "../../../../Components/Header/Header_Nav/Header_Nav.js";

export default function NAT_NUM_100_900_DECK() {
  return (
    <>
      <HeaderNav GoBack_to="/NumbersNav" />
      <FlashcardInterface deckData={NAT_NUM_100_900} title="Native Numbers: 100-900" />
    </>
  );
}
